import FilterGroup from './filters/filterGroup';
import Filter from './filters/filter';

export default class FilterableOverviewController {
    constructor() {
        this.container = null;
        this.letterFilterGroup = null;
        this.specialtyFilterGroup = null;

        if (document.querySelector('section.filterableOverview')) {
            this.container = document.querySelector('section.filterableOverview');
            this.init();
        }
    }

    init() {
        // Create filtergroup(s)
        const letterFilter = new Filter(this.container.querySelector('.filterInput[data-key="letter"]'));
        letterFilter.additive = true;
        letterFilter.singleOption = true; // So users can only select one, while still being able to uncheck
        letterFilter.init();

        this.letterFilterGroup = new FilterGroup([letterFilter], this.container.querySelectorAll('.filterableGroups > li'));
        this.letterFilterGroup.init();

        if (this.container.querySelector('select[name="specialty"]')) {
            const specialtyFilter = new Filter(this.container.querySelector('.filterInput[data-key="specialty"]'));
            specialtyFilter.isSelect = true;
            specialtyFilter.additive = true;
            specialtyFilter.init();

            this.specialtyFilterGroup = new FilterGroup([specialtyFilter], this.container.querySelectorAll('.filterList > li'));
            this.specialtyFilterGroup.init();
        }

        this.setEventListeners();
        
        if (this.specialtyFilterGroup) {
            this.specialtyFilterGroup.filters[0].element.dispatchEvent(new CustomEvent('update'));
        }
    }

    setEventListeners() {
        this.container.querySelector('.toggleFilterPopup').addEventListener('click', e => {
            if (!(window.innerWidth > app.breakpoints.md.size)) {
                this.container.querySelector('.popup').classList.add('active');
                document.documentElement.classList.add('disableScroll');
            }
        });

        this.container.querySelector('.closePopup').addEventListener('click', () => {
            this.container.querySelector('.popup').classList.remove('active');
            document.documentElement.classList.remove('disableScroll');
        });

        // Escape clears selection
        document.addEventListener('keydown', e => {
            if (e.key.toLowerCase().substr(0, 3) == 'esc') {
                this.letterFilterGroup.filters.forEach(filter => {
                    filter.dom.inputs.forEach(input => input.checked = false);
                    filter.update();
                });
            }

            this.container.querySelector('.closePopup').click();
        });

        app.registerResizeEvent(() => {
            if (window.innerWidth > app.breakpoints.md.size) {
                this.container.querySelector('.closePopup').click();
            }
        });

        this.shownTimeout = null;
        this.letterFilterGroup.filters[0].element.addEventListener('update', () => {
            if (window.innerWidth <= app.breakpoints.md.size) {
                this.container.querySelector('.closePopup').click();
            }

            this.letterFilterGroup.filterTargets.forEach(group => {
                if (group.classList.contains('filtered')) {
                    group.classList.remove('shown');
                } else {
                    group.classList.add('shown');
                }
            });

            if (this.specialtyFilterGroup && Object.keys(this.letterFilterGroup.filterData).length && Object.keys(this.specialtyFilterGroup.filterData).length) {
                this.specialtyFilterGroup.reset();
            }

            if (this.shownTimeout) {
                clearTimeout(this.shownTimeout);
            }

            if (this.shownTimeout) {
                clearTimeout(this.shownTimeout);
            }

            this.shownTimeout = setTimeout(() => {
                this.letterFilterGroup.filterTargets.forEach(group => group.classList.remove('shown'));
                clearTimeout(this.shownTimeout);
                this.shownTimeout = null;
            }, 400);
        });



        if (this.specialtyFilterGroup) {
            this.specialtyFilterGroup.filters[0].element.addEventListener('update', () => {
                if (Object.keys(this.specialtyFilterGroup.filterData).length) {
                    this.letterFilterGroup.reset();
                }

                // Check if there are empty groups. If so, mark them as filtered
                let set = new Set();
                this.letterFilterGroup.filterTargets.forEach(target => {
                    set.add(target.closest('[data-filter-letter]'));
                });

                this.letterFilterGroup.decideOnAllFilterTargets();

                set.forEach(item => {
                    if (!item.querySelectorAll('.filterList li:not(.filtered)').length) {
                        item.classList.add('filtered');
                    }
                });
            });
        }
    }
}